exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.calculator .more, .calculator .less {\n  border-radius: 3px;\n  border: 1px solid #c5d0de;\n  background: #fbfcfc;\n  padding: 0.4rem 1rem 0.5rem;\n  color: #8ca0b3;\n  cursor: pointer;\n}\n.calculator input[type=text] {\n  width: 48px;\n  text-align: center;\n  border-color: #c5d0de;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6ccd5b64","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/Calculator.vue
// module id = 1698
// module chunks = 0